var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section countdown-timer theme--white" },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _vm.countdowntitle || _vm.description || _vm.isExperienceEditor
          ? _c("header", { staticClass: "section__header" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "generic-text__header" }, [
                  _c("div", { staticClass: "text-block" }, [
                    _c("h2", { staticClass: "title" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.countdowntitle) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.description || _vm.isExperienceEditor
                  ? _c("div", { staticClass: "generic-text__content" }, [
                      _c("div", { staticClass: "text-block" }, [
                        _c("div", { staticClass: "wysiwyg" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.description) +
                              "\n                    "
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "section__content" }, [
          _c(
            "div",
            {
              staticClass: "countdown-timer__clock",
              attrs: { id: _vm.id + "_countdown" },
            },
            [
              _c("div", { staticClass: "countdown-timer__block" }, [
                _c("span", { class: _vm.countdownblockcolour }, [
                  _vm._v(_vm._s(_vm.daysCounter)),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.daysLabel))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "countdown-timer__block" }, [
                _c("span", { class: _vm.countdownblockcolour }, [
                  _vm._v(_vm._s(_vm.hoursCounter)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "timeRefHours" }, [
                  _vm._v(_vm._s(_vm.hoursLabel)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "countdown-timer__block" }, [
                _c("span", { class: _vm.countdownblockcolour }, [
                  _vm._v(_vm._s(_vm.minutesCounter)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "timeRefMinutes" }, [
                  _vm._v(_vm._s(_vm.minutesLabel)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "countdown-timer__block" }, [
                _c("span", { class: _vm.countdownblockcolour }, [
                  _vm._v(_vm._s(_vm.secondsCounter)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "timeRefSeconds" }, [
                  _vm._v(_vm._s(_vm.secondsLabel)),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          (_vm.btnonehref && _vm.btnonelabel) ||
          (_vm.btntwohref && _vm.btntwolabel)
            ? _c("div", { staticClass: "countdown-timer__buttons" }, [
                _vm.btnonehref && _vm.btnonelabel
                  ? _c(
                      "a",
                      {
                        staticClass: "btn countdown-timer__button btn--one",
                        class: _vm.btnonetheme,
                        attrs: {
                          href: _vm.btnonehref,
                          target: _vm.btnonetarget,
                        },
                      },
                      [
                        _c("span", { staticClass: "btn__content" }, [
                          _c("span", { staticClass: "btn__text" }, [
                            _vm._v(_vm._s(_vm.btnonelabel)),
                          ]),
                          _vm._v(" "),
                          _vm.btnoneicon == "True" &&
                          _vm.btnonetheme == "btn--blue"
                            ? _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 30 30",
                                  },
                                },
                                [
                                  _c("path", {
                                    staticClass: "donation-inside",
                                    attrs: {
                                      fill: "#ffd91b",
                                      d: "M26.3 5.2c-2.7-2.9-7.1-2.9-9.9-.3l-.3.3L15 6.3l-1.1-1.2C12.6 3.8 10.7 3 8.8 3S5 3.8 3.7 5.2C.9 8.1.9 12.8 3.7 15.7l10.4 11c.2.3.5.4.8.4s.6-.1.8-.4l.1-.1 10.4-11c2.9-2.8 2.9-7.5.1-10.4z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      fill: "#ffd91b",
                                      d: "M27.7 4c-3-3.2-8-3.3-11.1-.3l-.3.3L15 5.3 13.8 4c-1.5-1.6-3.6-2.4-5.7-2.4-2.2-.1-4.3.8-5.8 2.4-3.1 3.3-3.1 8.5 0 11.8L14 28.1c.2.3.6.4.9.4s.7-.1.9-.4l.1-.1 11.7-12.3c3.2-3.2 3.2-8.4.1-11.7zm-1.9 10L15 25.2 4.2 14a5.92 5.92 0 0 1 0-8.2c.9-1 2.2-1.6 3.6-1.7H8c1.5 0 2.8.6 3.8 1.7L14 8.1c.2.3.6.4.9.4s.7-.1.9-.4l.1-.1 2.2-2.3c1.9-2.1 5.2-2.3 7.3-.3l.3.3c2.2 2.4 2.2 6 .1 8.3z",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.btntwohref && _vm.btntwolabel
                  ? _c(
                      "a",
                      {
                        staticClass: "btn countdown-timer__button btn--two",
                        class: _vm.btntwotheme,
                        attrs: {
                          href: _vm.btntwohref,
                          target: _vm.btntwotarget,
                        },
                      },
                      [
                        _c("span", { staticClass: "btn__content" }, [
                          _c("span", { staticClass: "btn__text" }, [
                            _vm._v(_vm._s(_vm.btntwolabel)),
                          ]),
                          _vm._v(" "),
                          _vm.btntwoicon == "True" &&
                          _vm.btntwotheme == "btn--blue"
                            ? _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 30 30",
                                  },
                                },
                                [
                                  _c("path", {
                                    staticClass: "donation-inside",
                                    attrs: {
                                      fill: "#ffd91b",
                                      d: "M26.3 5.2c-2.7-2.9-7.1-2.9-9.9-.3l-.3.3L15 6.3l-1.1-1.2C12.6 3.8 10.7 3 8.8 3S5 3.8 3.7 5.2C.9 8.1.9 12.8 3.7 15.7l10.4 11c.2.3.5.4.8.4s.6-.1.8-.4l.1-.1 10.4-11c2.9-2.8 2.9-7.5.1-10.4z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      fill: "#ffd91b",
                                      d: "M27.7 4c-3-3.2-8-3.3-11.1-.3l-.3.3L15 5.3 13.8 4c-1.5-1.6-3.6-2.4-5.7-2.4-2.2-.1-4.3.8-5.8 2.4-3.1 3.3-3.1 8.5 0 11.8L14 28.1c.2.3.6.4.9.4s.7-.1.9-.4l.1-.1 11.7-12.3c3.2-3.2 3.2-8.4.1-11.7zm-1.9 10L15 25.2 4.2 14a5.92 5.92 0 0 1 0-8.2c.9-1 2.2-1.6 3.6-1.7H8c1.5 0 2.8.6 3.8 1.7L14 8.1c.2.3.6.4.9.4s.7-.1.9-.4l.1-.1 2.2-2.3c1.9-2.1 5.2-2.3 7.3-.3l.3.3c2.2 2.4 2.2 6 .1 8.3z",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }